import { createReduxStore, register } from "@wordpress/data";

export const MAGAZINE_BLOCKS_DEVICE_STORE: "magazine-blocks/device" =
	"magazine-blocks/device";

const INITIAL_STATE: {
	device: "desktop" | "mobile" | "tablet";
} = {
	device: "desktop",
};

export const deviceStore = createReduxStore(MAGAZINE_BLOCKS_DEVICE_STORE, {
	reducer(
		state = INITIAL_STATE,
		action: {
			type: string;
			payload: string;
		}
	) {
		switch (action.type) {
			case "SET_DEVICE":
				return { ...state, device: action.payload };
		}

		return state;
	},
	actions: {
		setDevice(device: string) {
			return {
				type: "SET_DEVICE",
				payload: device,
			};
		},
	},
	selectors: {
		getDevice(state: typeof INITIAL_STATE) {
			return state.device;
		},
	},
});

register(deviceStore);
